<template>
  <span>
    <ICountUp
      :startVal="start"
      :endVal="Number(end)"
      :decimals="decimals"
      :duration="duration"
      :options="options"
    />
  </span>
</template>

<script>
import ICountUp from "vue-countup-v2";
export default {
  name: "Counter",
  components: {
    ICountUp
  },
  props: {
    start: {
      default: 0
    },
    end: {
      default: 100
    },
    decimals: {
      default: 2
    },
    duration: {
      default: 2
    }
  },
  data: function() {
    return {
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ".",
        decimal: ",",
        prefix: "",
        suffix: ""
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/base-components/base-counter.vue